import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrintLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import PN from "persian-number";


const PrintTransferIndex = () => {

    //#region Const
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();

    const [ItemList, setItemList] = useState([]);
    const [Tax, setTax] = useState(0);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Code, setCode] = useState("");
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [ShowDis, setShowDis] = useState(0);

    const [StoreRoom, setStoreRoom] = useState("");
    const [TypeComment, setTypeComment] = useState("");
    const [Type, setType] = useState(-1);
    const [InsertDate, setInsertDate] = useState("");
    const [Supplier, setSupplier] = useState("");


    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomTransfer/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': localStorage.getItem("TransferHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(result.insertDate)
                    setTypeComment(result.typeComment);
                    setType(result.type);
                    setHeaderPrice(result.price);
                    setStoreRoom(result.storeRoom);
                    setSupplier(result.supplier);
                    setCode(result.code);
                    setItemList(result.children);
                    setTax(result.children[0].tax)
                    setShowDis(result.children.findIndex(x => x.discountPercent != 0))


                })
        )
    }




    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", localStorage.getItem("Page"));
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetById();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = "چاپ حواله/ رزرو ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion



    return (

        <Layout title={" چاپ " + TypeComment}>
            <div className="print-content" >
                <div className={localStorage.getItem("HeaderFontSize_Store") + " p-1 "}>
                    <table class="table table-sm table-borderless">
                        <tr>
                            <td>
                                {Type==8 || Type ==9 ? <b>شماره رزرو :   </b> : <b>شماره حواله :   </b>}{Code}
                            </td>
                            <td className='text-end'>
                                <b> تاریخ صدور:   </b> {InsertDate}
                            </td>
                            <td className='text-end'>
                                <b> انبار مبدا:   </b> {StoreRoom}
                            </td>
                            <td className={Type == 1 || Type == 3 || Type == 4  || Type == 5  || Type == 8|| Type == 9  ? 'text-end' : "hide"}>
                                <b> تحویل  گیرنده: </b> {Supplier}
                            </td>
                            <td className={Type == 2 ? 'text-end' : "hide"}>
                                <b> انبار مقصد: </b> {Supplier}
                            </td>

                        </tr>
                        <tr>
                            <td colSpan={5} className='pt-2'>
                                <b> مبلغ کل  {TypeComment}  : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                                &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                            </td>
                        </tr>

                    </table>


                </div>
                <hr />

                <div className={localStorage.getItem("FontSize_Store") + " p-1 "}>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>
                                    #
                                </th>
                                <th className={Type == 1 || Type == 3 ? 'text-start' : "hide"}>
                                    مبنا
                                </th>
                                <th className='text-end'>
                                    محصول
                                </th>
                                <th className='text-center'>
                                    تعداد
                                </th>
                                <th className='text-start'>
                                    قیمت واحد (ریال)
                                </th>
                                <th className={ShowDis != -1 ? 'text-start' : 'hide'}>
                                    تخفیف (%)
                                </th>
                                <th className={ShowDis != -1 ? 'text-start' : 'hide'}>
                                    تخفیف واحد (ریال)
                                </th>

                                <th className={Tax == 0 ? 'hide' : 'text-start'}>
                                    مالیات واحد (ریال)
                                </th>
                                <th className='text-start'>
                                    قیمت کل (ریال)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ItemList.map((rowData, index) => (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td className={Type == 1 || Type == 3 ? 'text-start' : "hide"}>{rowData.refTitle}</td>
                                    <td className='text-end'>{rowData.product} </td>
                                    <td className='text-center'>{rowData.count}</td>
                                    <td className='text-start'> {PN.sliceNumber(rowData.price)}</td>
                                    <td className={ShowDis != -1 ? 'text-start' : 'hide'}> {PN.sliceNumber(rowData.discountPercent)}</td>
                                    <td className={ShowDis != -1 ? 'text-start' : 'hide'}> {PN.sliceNumber(rowData.discountPrice)}</td>
                                    <td className={Tax == 0 ? 'hide' : 'text-start'}> {PN.sliceNumber(rowData.tax)}</td>
                                    <td className='text-start'> {PN.sliceNumber(rowData.totalPrice)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
                <table class=" table table-sm table-borderless">

                    <tr>
                        <td colSpan={2} className={localStorage.getItem("footer_Store") != null && localStorage.getItem("footer_Store") != "" ? localStorage.getItem("CommentFontSize_Store") : "hide"}>
                            <div dangerouslySetInnerHTML={{ __html: localStorage.getItem("footer_Store").replaceAll(/\//g, '<br/>') }} />

                        </td>
                    </tr>
                    <tr>

                        <td className={localStorage.getItem("CommentFontSize_Store") + ' text-center'}>
                            <br />
                            <br />
                            امضا انباردار
                            :{localStorage.getItem("UserFullName")}
                            <br />
                            <br />

                        </td>
                        <td className={localStorage.getItem("CommentFontSize_Store") + ' text-center'}>
                            <br />
                            <br />
                            امضا تحویل دهنده
                            :
                            <br />

                            <br />

                        </td>


                    </tr>

                </table>

            </div >




        </Layout >


    )
}

export default PrintTransferIndex;